import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

const AttrArrayInput = ({
  attrs, platform, name, updateField, InputComponent, attrArray, ...rest
}) => {
  const key = `${platform}.${name}`
  function handleChange (attr, value) {
    updateField('attrs', { platform, name, lang: null }, value)
    attrs.set(key, value !== null ? value.toString() : value)
  }

  const value = attrs.has(key) ? attrs.get(key).toString() : ''
  const record = { // hack to remove observing in InputComponent
    get: () => value
  }
  const attrValue = attrArray && attrArray.find((i) => key === (i.platform + '.' + i.name))

  return (
    <InputComponent attrValue={attrValue && attrValue.value} record={record} attr={key} {...rest} onChange={handleChange} />
  )
}
AttrArrayInput.propTypes = {
  attrs: PropTypes.object,
  attrArray: PropTypes.object,
  platform: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  InputComponent: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired
}
export default observer(AttrArrayInput)
